import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import homeData from '../data/home.json';

const splashExpiresAt = new Date('2026-07-01T00:00:00+02:00');

function Home() {
  const [showSplash, setShowSplash] = useState(() => new Date() < splashExpiresAt);
  const { hero, visionMission, coreValues, impact, involvement } = homeData;
  const [vision, mission] = visionMission.cards;

  useEffect(() => {
    if (!showSplash) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setShowSplash(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showSplash]);

  return (
    <div className="fade-in">
      {showSplash && (
        <div
          className="home-splash"
          role="presentation"
          onMouseDown={() => setShowSplash(false)}
        >
          <div
            className="home-splash-content"
            role="dialog"
            aria-modal="true"
            aria-label="Hindu of the Year 2026 announcement"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="home-splash-close"
              aria-label="Close announcement"
              onClick={() => setShowSplash(false)}
            >
              &times;
            </button>
            <Link to="/upcoming-events" onClick={() => setShowSplash(false)}>
              <img
                src="/hindu-of-the-year-2026-splash2.jpg"
                alt="Shantik Foundation Hindu of the Year 2026"
                className="home-splash-image"
              />
            </Link>
          </div>
        </div>
      )}

      <div className="hero">
        <h1>{hero.title}</h1>
        <h2>{hero.subtitle}</h2>
        <p>{hero.text}</p>
      </div>

      <div className="content-section container vision-mission-section">
        <h2>{visionMission.title}</h2>
        <div className="cards-container">
          <div className="card vision-mission-card">
            <h3>{vision.title}</h3>
            <p>{vision.text}</p>
          </div>
          <div className="card vision-mission-card">
            <h3>{mission.title}</h3>
            <p>{mission.text}</p>
            <ol className="mission-list">
              {mission.links.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="mission-link">{item.label}</Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>

      <div className="content-section container">
        <h2>{coreValues.title}</h2>
        <div className="values-grid">
          {coreValues.items.map((value) => (
            <div key={value} className="value-item">{value}</div>
          ))}
        </div>
      </div>

      <div className="content-section container impact-section">
        <h2>{impact.title}</h2>
        <div className="cards-container">
          {impact.cards.map((card) => (
            <div key={card.title} className="card impact-card">
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container" style={{ textAlign: 'center' }}>
        <h2>{involvement.title}</h2>
        <p>{involvement.text}</p>
        {involvement.links.map((link) => (
          <Link key={link.to} to={link.to} className={link.className}>{link.label}</Link>
        ))}
      </div>
    </div>
  );
}

export default Home;
